/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ questions: NonNullable<unknown>, answered: NonNullable<unknown> }} Interview_Prepare_Session_StatsInputs */

const en_interview_prepare_session_stats = /** @type {(inputs: Interview_Prepare_Session_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.questions} questions, ${i?.answered} answered`)
};

const de_interview_prepare_session_stats = /** @type {(inputs: Interview_Prepare_Session_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.questions} Fragen, ${i?.answered} beantwortet`)
};

const fr_interview_prepare_session_stats = /** @type {(inputs: Interview_Prepare_Session_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.questions} questions, ${i?.answered} répondues`)
};

const es_interview_prepare_session_stats = /** @type {(inputs: Interview_Prepare_Session_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.questions} preguntas, ${i?.answered} respondidas`)
};

const it_interview_prepare_session_stats = /** @type {(inputs: Interview_Prepare_Session_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.questions} domande, ${i?.answered} con risposta`)
};

const nl_interview_prepare_session_stats = /** @type {(inputs: Interview_Prepare_Session_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.questions} vragen, ${i?.answered} beantwoord`)
};

const pl_interview_prepare_session_stats = /** @type {(inputs: Interview_Prepare_Session_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.questions} pytań, ${i?.answered} odpowiedzi`)
};

const fi_interview_prepare_session_stats = /** @type {(inputs: Interview_Prepare_Session_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.questions} kysymystä, ${i?.answered} vastattu`)
};

const da_interview_prepare_session_stats = /** @type {(inputs: Interview_Prepare_Session_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.questions} spørgsmål, ${i?.answered} besvaret`)
};

const sv_interview_prepare_session_stats = /** @type {(inputs: Interview_Prepare_Session_StatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.questions} frågor, ${i?.answered} besvarade`)
};

/**
* | output |
* | --- |
* | "{questions} questions, {answered} answered" |
*
* @param {Interview_Prepare_Session_StatsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_session_stats = /** @type {((inputs: Interview_Prepare_Session_StatsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Session_StatsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_session_stats(inputs)
	if (locale === "fr") return fr_interview_prepare_session_stats(inputs)
	if (locale === "es") return es_interview_prepare_session_stats(inputs)
	if (locale === "it") return it_interview_prepare_session_stats(inputs)
	if (locale === "nl") return nl_interview_prepare_session_stats(inputs)
	if (locale === "pl") return pl_interview_prepare_session_stats(inputs)
	if (locale === "fi") return fi_interview_prepare_session_stats(inputs)
	if (locale === "da") return da_interview_prepare_session_stats(inputs)
	if (locale === "sv") return sv_interview_prepare_session_stats(inputs)
	return en_interview_prepare_session_stats(inputs)
});